import { styled, Text } from '@volkswagen-onehub/components-core';

export const StyledBalanceText = styled(Text)`
	text-wrap: balance !important;
`;
